import styled from "styled-components"
import { TextButton, TextDiv, TextSpan } from "../common/Text"
import { QuizItemType } from "../../types"
import quizSections from "./quizSections"
import { useState } from "react"

const QuizItemSample = () => {
  const sampleItem: QuizItemType[] = [
    {
      description:
        "드로잉의 본질적 요소를 파악하고 개인의 시각경험, 관찰습관을 특성화시켜 표현하는 방법을 연습 대상에 대한 주관적인 해석을 통해 작업의도에 따르는 효과적인 재료의 선택 및 구체적인 방법론을 연구함",
      item_id: 1,
      item: "드로잉",
      lv2: "",
      lv4: "",
      section: "지식",
      sub_section: "",
      weight: "",
    },
    {
      description:
        "사회는 급변하며, 종교는 항상 사회와 양립할 수 있어야 하기에 새로운 사회적 규범과 가치하에서 종교를 새롭게 해석하고 연구하는 순발력과 적응력이 요구됨",
      item_id: 2,
      item: "적응력",
      lv2: "",
      lv4: "",
      section: "역량",
      sub_section: "",
      weight: "",
    },
    {
      description:
        "인간과 관련된 근원적인 문제나 사상, 문화등을 자기만의 독창적인 방법으로 표현",
      item_id: 3,
      item: "인문학",
      lv2: "",
      lv4: "",
      section: "흥미",
      sub_section: "",
      weight: "",
    },
    {
      description:
        "자신의 능력을 활용하여 사회에 기여하기 위해 다양한 기관에서 봉사함",
      item_id: 4,
      item: "사회봉사",
      lv2: "",
      lv4: "",
      section: "가치",
      sub_section: "",
      weight: "",
    },
    {
      description:
        "실험 과정에서 등장하는 다양한 변수에 대해 유동적으로 통제하며 결과에 미치는 영향을 이해할 수 있음",
      item_id: 5,
      item: "유연성",
      lv2: "",
      lv4: "",
      section: "개인특성",
      sub_section: "",
      weight: "",
    },
  ]

  const [sectionIdx, setSectionIdx] = useState(0)
  const [selectedOption, setSelectedOption] = useState<number | null>(null)

  return (
    <QuizItemDiv key={`sample-${sectionIdx}`}>
      <SectionSelector>
        <TextButton
          fontSize={15}
          color={sectionIdx === 0 ? "var(--custom-blue)" : ""}
          onClick={() => {
            setSectionIdx(0)
            setSelectedOption(null)
          }}
        >
          지식
        </TextButton>
        <TextButton
          fontSize={15}
          color={sectionIdx === 1 ? "var(--custom-blue)" : ""}
          onClick={() => {
            setSectionIdx(1)
            setSelectedOption(null)
          }}
        >
          역량
        </TextButton>
        <TextButton
          fontSize={15}
          color={sectionIdx === 2 ? "var(--custom-blue)" : ""}
          onClick={() => {
            setSectionIdx(2)
            setSelectedOption(null)
          }}
        >
          흥미
        </TextButton>
        <TextButton
          fontSize={15}
          color={sectionIdx === 3 ? "var(--custom-blue)" : ""}
          onClick={() => {
            setSectionIdx(3)
            setSelectedOption(null)
          }}
        >
          가치
        </TextButton>
        <TextButton
          fontSize={15}
          color={sectionIdx === 4 ? "var(--custom-blue)" : ""}
          onClick={() => {
            setSectionIdx(4)
            setSelectedOption(null)
          }}
        >
          개인특성
        </TextButton>
      </SectionSelector>
      <TextDiv
        fontSize={16}
        $align="start"
        style={{ marginBottom: 15, marginTop: 10 }}
      >
        {`${quizSections[sectionIdx].responseGuide} `}
        <TextSpan fontSize={16} color="var(--custom-light-red)">
          {quizSections[sectionIdx].responseOptions[0]}
          <TextSpan
            fontSize={14}
            color="var(--custom-gray)"
          >{`(1점)`}</TextSpan>
          <TextSpan fontSize={16}>{`, `}</TextSpan>
        </TextSpan>
        <TextSpan fontSize={16} color="var(--custom-salmon-pink)">
          {quizSections[sectionIdx].responseOptions[1]}
          <TextSpan
            fontSize={14}
            color="var(--custom-gray)"
          >{`(2점)`}</TextSpan>
          <TextSpan fontSize={16}>{`, `}</TextSpan>
        </TextSpan>
        <TextSpan fontSize={16} color="var(--custom-gray)">
          {quizSections[sectionIdx].responseOptions[2]}
          <TextSpan
            fontSize={14}
            color="var(--custom-gray)"
          >{`(3점)`}</TextSpan>
          <TextSpan fontSize={18}>{`, `}</TextSpan>
        </TextSpan>
        <TextSpan fontSize={16} color="var(--custom-light-blue)">
          {quizSections[sectionIdx].responseOptions[3]}
          <TextSpan
            fontSize={14}
            color="var(--custom-gray)"
          >{`(4점)`}</TextSpan>
          <TextSpan fontSize={16}>{`, `}</TextSpan>
        </TextSpan>
        <TextSpan fontSize={16} color="var(--custom-blue)">
          {quizSections[sectionIdx].responseOptions[4]}
          <TextSpan
            fontSize={14}
            color="var(--custom-gray)"
          >{`(5점)`}</TextSpan>
        </TextSpan>
        로 응답해주세요.
      </TextDiv>
      <hr />
      <QuizDescriptionDiv>
        <TextSpan fontSize={16} fontWeight="bold">
          {`[${sampleItem[sectionIdx].item}] ${
            sampleItem[sectionIdx].description
              ? sampleItem[sectionIdx].description
              : "(이 문항은 별도의 설명이 없습니다)"
          }`}
        </TextSpan>
      </QuizDescriptionDiv>
      <ButtonContainer id={`sample-response-${sampleItem[sectionIdx].item_id}`}>
        {quizSections[sectionIdx].responseLabels.map((option, index) => {
          return (
            <ButtonDiv
              key={`response-${sampleItem[sectionIdx].item_id}-${index}`}
            >
              <RadioButton
                id={`response-${sampleItem[sectionIdx].item_id}-${index}`}
                value={index}
                $colorIdx={index}
                checked={selectedOption === index}
                onClick={() => setSelectedOption(index)}
              />
            </ButtonDiv>
          )
        })}
      </ButtonContainer>
      <LabelContainer>
        {quizSections[sectionIdx].responseLabels.map((option, index) => {
          return (
            <TextDiv
              key={`response-${sampleItem[sectionIdx].item_id}-label-${index}`}
              fontSize={12}
            >
              {option}
            </TextDiv>
          )
        })}
      </LabelContainer>
    </QuizItemDiv>
  )
}

export default QuizItemSample

const SectionSelector = styled.span`
  display: flex;
  gap: 20px;
  border-radius: 15px;
  box-sizing: border-box;
  background-color: var(--custom-platinum);
  padding: 10px;
  width: 280px;
`

const QuizDescriptionDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const ButtonContainer = styled.div`
  margin-top: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  & > * {
    width: 52px;
  }

  @media ${({ theme }) => theme.device.pc} {
    width: 60%;
    margin: 15px auto 0px;
  }
`

const LabelContainer = styled.div`
  margin-top: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  & > * {
    width: 52px;
  }

  @media ${({ theme }) => theme.device.pc} {
    width: 60%;
    margin: 15px auto 0px;
  }
`

const QuizItemDiv = styled.div`
  width: 100%;
  border-radius: 20px;
  box-sizing: border-box;
  background-color: var(--custom-white-smoke);
  padding: 20px 10px;
`

const ButtonDiv = styled.div`
  display: flex;
  justify-content: center;
`

const RadioButton = styled.input.attrs(() => ({
  type: "radio",
  readOnly: true,
}))<{ $colorIdx: number }>`
  margin: 0;
  appearance: none;
  border: 0px solid var(--custom-platinum);
  outline: 2px solid var(--custom-dark-brown);
  border-radius: 50%;
  width: ${(props) =>
    props.$colorIdx === 0
      ? "30px"
      : props.$colorIdx === 1
      ? "25px"
      : props.$colorIdx === 2
      ? "22px"
      : props.$colorIdx === 3
      ? "25px"
      : "30px"};
  height: ${(props) =>
    props.$colorIdx === 0
      ? "30px"
      : props.$colorIdx === 1
      ? "25px"
      : props.$colorIdx === 2
      ? "22px"
      : props.$colorIdx === 3
      ? "25px"
      : "30px"};
  transition: border 0.1s ease;

  &:checked {
    border-width: 6px;
    background-color: ${(props) =>
      props.$colorIdx === 0
        ? "var(--custom-light-red)"
        : props.$colorIdx === 1
        ? "var(--custom-salmon-pink)"
        : props.$colorIdx === 2
        ? "var(--custom-gray)"
        : props.$colorIdx === 3
        ? "var(--custom-light-blue)"
        : "var(--custom-blue)"};
  }

  &:hover {
    border-width: 6px;
    background-color: ${(props) =>
      props.$colorIdx === 0
        ? "var(--custom-light-red)"
        : props.$colorIdx === 1
        ? "var(--custom-salmon-pink)"
        : props.$colorIdx === 2
        ? "var(--custom-gray)"
        : props.$colorIdx === 3
        ? "var(--custom-light-blue)"
        : "var(--custom-blue)"};
  }
`
